import React, { useEffect, useState } from 'react'
import {
    Table,
    Container,
    Spinner,
    Alert,
    Modal,
    Button,
    Form,
    Pagination,
} from 'react-bootstrap'
import {
    FaBoxes,
    FaEdit,
    FaSearchPlus,
    FaCheck,
    FaTimes,
    FaSave,
    FaExclamation,
} from 'react-icons/fa'
import apinode from '../../services/apinode'
import { toast } from 'react-toastify'
import Navbar from '../../components/navbar/navbar'

const ContasList = () => {
    const [contas, setContas] = useState([])
    const [loading, setLoading] = useState(true)
    const [erro, setErro] = useState(null)

    const [showModalItens, setShowModalItens] = useState(false)
    const [armazemSelecionado, setArmazemSelecionado] = useState(null)
    const [itensArmazem, setItensArmazem] = useState([])
    const [filtroItens, setFiltroItens] = useState('')
    const [paginaAtual, setPaginaAtual] = useState(1)
    const itensPorPagina = 50
    const [loadingItens, setLoadingItens] = useState(false)

    // Controle dos valores alterados do estoque
    const [estoquesAlterados, setEstoquesAlterados] = useState({}) // { sku: novo_estoque }
    const [loadingAtualizarEstoque, setLoadingAtualizarEstoque] = useState({}) // { sku: true/false }

    // Modal busca produtos para inclusão
    const [showModalBuscaProduto, setShowModalBuscaProduto] = useState(false)
    const [buscaProduto, setBuscaProduto] = useState('')
    const [resultadosBuscaProduto, setResultadosBuscaProduto] = useState([])
    const [loadingBuscaProduto, setLoadingBuscaProduto] = useState(false)

    // Produtos selecionados para inclusão (armazenados por SKU)
    const [produtosSelecionados, setProdutosSelecionados] = useState({})

    // Modal confirmação inclusão múltipla
    const [showModalConfirmarInclusao, setShowModalConfirmarInclusao] = useState(false)

    // Loading para cada SKU ao incluir no armazém
    const [loadingInclusao, setLoadingInclusao] = useState({})

    useEffect(() => {
        const buscarArmazens = async () => {
            try {
                const res = await apinode.get(`/listararmazens/${localStorage.idconta}`)
                setContas(res.data)
            } catch (err) {
                setErro('Erro ao buscar armazéns.')
            } finally {
                setLoading(false)
            }
        }
        buscarArmazens()
    }, [])

    const abrirModalItens = async (armazem) => {
        setArmazemSelecionado(armazem)
        setLoadingItens(true)
        setPaginaAtual(1)
        setEstoquesAlterados({})
        try {
            const res = await apinode.get(`/itensarmazem/${armazem.CODIGO}/${localStorage.idconta}`)
            setItensArmazem(res.data)
        } catch {
            setItensArmazem([])
            alert('Erro ao carregar itens do armazém.')
        } finally {
            setLoadingItens(false)
            setShowModalItens(true)
        }
    }

    const fecharModalItens = () => {
        setShowModalItens(false)
        setItensArmazem([])
        setFiltroItens('')
        setPaginaAtual(1)
        setArmazemSelecionado(null)
        setEstoquesAlterados({})
    }

    // Atualizar valor de estoque na tabela (input)
    const alterarEstoqueLocal = (sku, valor) => {
        // Permitir só números positivos ou zero
        if (valor === '' || /^[0-9]*$/.test(valor)) {
            setEstoquesAlterados((prev) => ({
                ...prev,
                [sku]: valor === '' ? '' : Number(valor),
            }))
        }
    }

    // Salvar atualização do estoque para SKU
    const salvarAlteracaoEstoque = async (sku) => {
        // Validação mais robusta do valor
        const novoEstoque = estoquesAlterados[sku];

        if (novoEstoque === undefined || novoEstoque === '' || novoEstoque === null) {
            alert('Informe um valor válido para o estoque.');
            return;
        }

        // Validar se é um número válido
        const estoqueNumerico = parseFloat(novoEstoque);
        if (isNaN(estoqueNumerico) || estoqueNumerico < 0) {
            alert('Informe um valor numérico válido para o estoque.');
            return;
        }

        // Validar se armazém está selecionado
        if (!armazemSelecionado || !armazemSelecionado.CODIGO) {
            alert('Selecione um armazém válido.');
            return;
        }

        setLoadingAtualizarEstoque((prev) => ({ ...prev, [sku]: true }));

        try {
            // Requisição para atualizar estoque
            await apinode.put(`/atualizarestoque/${localStorage.idconta}`, {
                id_conta: localStorage.idconta,
                cod_armazem: armazemSelecionado.CODIGO,
                sku,
                novo_estoque: estoqueNumerico, // Usar valor numérico
            });

            // Atualizar lista de itens para refletir alteração
            const res = await apinode.get(`/itensarmazem/${armazemSelecionado.CODIGO}/${localStorage.idconta}`);
            setItensArmazem(res.data);

            // Limpar alteração local do SKU
            setEstoquesAlterados((prev) => {
                const novo = { ...prev };
                delete novo[sku];
                return novo;
            });

            toast.success(`Estoque do SKU ${sku} atualizado com sucesso!`);

        } catch (error) {
            console.error('Erro ao atualizar estoque:', error);

            // Mensagem de erro mais específica
            const mensagemErro = error.response?.data?.message ||
                error.response?.data?.erro ||
                'Erro desconhecido ao atualizar estoque';

            toast.error(`Erro ao atualizar estoque do SKU ${sku}: ${mensagemErro}`);

        } finally {
            setLoadingAtualizarEstoque((prev) => ({ ...prev, [sku]: false }));
        }
    };

    // Abrir modal busca produto
    const abrirModalBuscaProduto = () => {
        setBuscaProduto('')
        setResultadosBuscaProduto([])
        setShowModalBuscaProduto(true)
    }

    const fecharModalBuscaProduto = () => {
        setShowModalBuscaProduto(false)
    }

    const buscarProdutoAPI = async () => {
        if (!buscaProduto.trim()) return
        setLoadingBuscaProduto(true)
        try {
            const res = await apinode.get('estoque/listaproduto', {
                params: { sku: buscaProduto.trim(), conta: localStorage.idconta },
            })
            setResultadosBuscaProduto(res.data || [])
        } catch (err) {
            alert('Erro na busca de produtos.')
        } finally {
            setLoadingBuscaProduto(false)
        }
    }

    // Alterna seleção do produto na busca (checkbox)
    const toggleProdutoSelecionado = (produto) => {
        setProdutosSelecionados((prev) => {
            const novo = { ...prev }
            if (novo[produto.SKU]) {
                delete novo[produto.SKU]
            } else {
                novo[produto.SKU] = produto
            }
            return novo
        })
    }

    // Confirma inclusão em lote: abre modal confirmação
    const abrirModalConfirmarInclusao = () => {
        if (Object.keys(produtosSelecionados).length === 0) {
            alert('Nenhum produto selecionado.')
            return
        }
        setShowModalConfirmarInclusao(true)
    }

    const fecharModalConfirmarInclusao = () => {
        setShowModalConfirmarInclusao(false)
    }

    // Incluir todos os produtos selecionados no armazém (em sequência)
    const incluirProdutosSelecionados = async () => {
        if (!armazemSelecionado) return
        const skus = Object.keys(produtosSelecionados)
        for (const sku of skus) {
            setLoadingInclusao((prev) => ({ ...prev, [sku]: true }))
            try {
                await apinode.post(`/incluirprodutoarmazem/${localStorage.idconta}`, {
                    id_conta: localStorage.idconta,
                    cod_armazem: armazemSelecionado.CODIGO,
                    sku,
                })
                // Atualizar lista de itens após inclusão
                const res = await apinode.get(`/itensarmazem/${armazemSelecionado.CODIGO}/${localStorage.idconta}`)
                setItensArmazem(res.data)
                // Remover SKU da seleção
                setProdutosSelecionados((prev) => {
                    const novo = { ...prev }
                    delete novo[sku]
                    return novo
                })
            } catch {
                toast.error(`Erro ao incluir produto SKU ${sku}`)
            } finally {
                setLoadingInclusao((prev) => ({ ...prev, [sku]: false }))
                toast.success(`${sku}, atualizado com sucesso!`)
            }
        }
        setShowModalConfirmarInclusao(false)
    }

    // Itens filtrados e paginados
    const itensFiltrados = itensArmazem.filter(
        (item) =>
            item.sku?.toLowerCase().includes(filtroItens.toLowerCase()) ||
            item.descricao?.toLowerCase().includes(filtroItens.toLowerCase())
    )

    const totalPaginas = Math.ceil(itensFiltrados.length / itensPorPagina)
    const itensPagina = itensFiltrados.slice(
        (paginaAtual - 1) * itensPorPagina,
        paginaAtual * itensPorPagina
    )

    const renderPaginacao = () => {
        if (totalPaginas <= 1) return null

        const paginas = []
        const delta = 2 // quantas páginas antes/depois da atual mostrar
        const esquerda = Math.max(2, paginaAtual - delta)
        const direita = Math.min(totalPaginas - 1, paginaAtual + delta)

        let exibiuPontoEsquerda = false
        let exibiuPontoDireita = false

        // Página 1 sempre aparece
        paginas.push(
            <Pagination.Item
                key={1}
                active={paginaAtual === 1}
                onClick={() => setPaginaAtual(1)}
            >
                1
            </Pagination.Item>
        )

        for (let i = 2; i <= totalPaginas - 1; i++) {
            if (i >= esquerda && i <= direita) {
                paginas.push(
                    <Pagination.Item
                        key={i}
                        active={paginaAtual === i}
                        onClick={() => setPaginaAtual(i)}
                    >
                        {i}
                    </Pagination.Item>
                )
            } else {
                if (i < esquerda && !exibiuPontoEsquerda) {
                    paginas.push(<Pagination.Ellipsis key="ponto-esquerda" disabled />)
                    exibiuPontoEsquerda = true
                }
                if (i > direita && !exibiuPontoDireita) {
                    paginas.push(<Pagination.Ellipsis key="ponto-direita" disabled />)
                    exibiuPontoDireita = true
                }
            }
        }

        // Última página sempre aparece se maior que 1
        if (totalPaginas > 1) {
            paginas.push(
                <Pagination.Item
                    key={totalPaginas}
                    active={paginaAtual === totalPaginas}
                    onClick={() => setPaginaAtual(totalPaginas)}
                >
                    {totalPaginas}
                </Pagination.Item>
            )
        }

        return (
            <Pagination>
                <Pagination.Prev
                    onClick={() => paginaAtual > 1 && setPaginaAtual(paginaAtual - 1)}
                    disabled={paginaAtual === 1}
                />
                {paginas}
                <Pagination.Next
                    onClick={() =>
                        paginaAtual < totalPaginas && setPaginaAtual(paginaAtual + 1)
                    }
                    disabled={paginaAtual === totalPaginas}
                />
            </Pagination>
        )
    }


    if (loading) return <Spinner animation="border" />
    if (erro) return <Alert variant="danger">{erro}</Alert>

    return (
        <>
         <Navbar />
        <Container className="mt-page">
            <h4>Lista de Armazéns</h4>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Código</th>
                        <th>Descrição</th>
                        <th>CNPJ Empresa</th>
                        <th>ID Conta</th>
                        <th>Tipo</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {contas.map((conta) => (
                        <tr key={conta.CODIGO}>
                            <td>{conta.CODIGO}</td>
                            <td>{conta.DESCRICAO}</td>
                            <td>{conta.CNPJ_EMPRESA || '-'}</td>
                            <td>{conta.ID_CONTA}</td>
                            <td>{conta.TIPO || '-'}</td>
                            <td>
                                <Button
                                    variant="info"
                                    size="sm"
                                    onClick={() => abrirModalItens(conta)}
                                >
                                    <FaBoxes /> Itens
                                </Button>{' '}
                                <Button variant="warning" size="sm">
                                    <FaEdit /> Editar
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {/* Modal Itens do Armazém */}
            <Modal
                size="lg"
                show={showModalItens}
                onHide={fecharModalItens}
                scrollable
                dialogClassName="custom-modalzpl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Itens do Armazém: {armazemSelecionado?.DESCRICAO || ''}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Button variant="primary" onClick={abrirModalBuscaProduto} className="mb-3">
                        <FaSearchPlus /> Incluir Produto
                    </Button>

                    <Form.Control
                        placeholder="Filtrar por SKU ou descrição..."
                        value={filtroItens}
                        onChange={(e) => {
                            setFiltroItens(e.target.value)
                            setPaginaAtual(1)
                        }}
                        className="mb-3"
                    />

                    {loadingItens ? (
                        <Spinner animation="border" />
                    ) : (
                        <>
                            <Table striped bordered hover size="sm">
                                <thead>
                                    <tr>
                                        <th>SKU</th>
                                        <th>Descrição</th>
                                        <th>Estoque Atual</th>
                                        <th>Alterar Estoque</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {itensPagina.length === 0 && (
                                        <tr>
                                            <td colSpan={4} className="text-center">
                                                Nenhum item encontrado.
                                            </td>
                                        </tr>
                                    )}
                                    {itensPagina.map((item) => {
                                        // Verifica se há alteração pendente para este SKU
                                        const temAlteracaoPendente = estoquesAlterados[item.sku] !== undefined &&
                                            estoquesAlterados[item.sku] !== item.estoque_atual;

                                        return (
                                            <tr key={item.sku}>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        {item.sku}
                                                        {/* Ícone vermelho para alterações pendentes */}
                                                        {temAlteracaoPendente && (
                                                            <span
                                                                className="ms-2 text-danger"
                                                                title="Alteração pendente - não salva"
                                                            >
                                                                <FaExclamation />
                                                            </span>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>{item.descricao}</td>
                                                <td>{item.estoque_atual}</td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <Form.Control
                                                            type="number"
                                                            min={0}
                                                            value={
                                                                estoquesAlterados[item.sku] !== undefined
                                                                    ? estoquesAlterados[item.sku]
                                                                    : item.estoque_atual
                                                            }
                                                            onChange={(e) =>
                                                                alterarEstoqueLocal(item.sku, e.target.value)
                                                            }
                                                            style={{
                                                                width: '100px',
                                                                borderColor: temAlteracaoPendente ? '#dc3545' : '#ced4da' // Borda vermelha se pendente
                                                            }}
                                                            disabled={loadingAtualizarEstoque[item.sku]}
                                                        />
                                                        <Button
                                                            variant={temAlteracaoPendente ? "warning" : "success"}
                                                            size="sm"
                                                            onClick={() => salvarAlteracaoEstoque(item.sku)}
                                                            disabled={loadingAtualizarEstoque[item.sku] || !temAlteracaoPendente}
                                                            className="ms-2"
                                                            title={temAlteracaoPendente ? "Salvar alteração" : "Nenhuma alteração"}
                                                        >
                                                            {loadingAtualizarEstoque[item.sku] ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : temAlteracaoPendente ? (
                                                                <FaSave />
                                                            ) : (
                                                                <FaCheck />
                                                            )}
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            {renderPaginacao()}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={fecharModalItens}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal Busca Produto para Incluir */}
            <Modal
                size="lg"
                show={showModalBuscaProduto}
                onHide={fecharModalBuscaProduto}
                scrollable
                dialogClassName="custom-modalzpl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Buscar Produtos para Incluir</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="buscaProduto">
                        <Form.Label>SKU ou descrição</Form.Label>
                        <Form.Control
                            type="text"
                            value={buscaProduto}
                            onChange={(e) => setBuscaProduto(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && buscarProdutoAPI()}
                            placeholder="Digite o SKU ou descrição e pressione Enter"
                        />
                    </Form.Group>
                    <Button onClick={buscarProdutoAPI} disabled={loadingBuscaProduto}>
                        {loadingBuscaProduto ? (
                            <Spinner animation="border" size="sm" />
                        ) : (
                            'Buscar'
                        )}
                    </Button>

                    <Table striped bordered hover size="sm" className="mt-3">
                        <thead>
                            <tr>
                                <th>Selecionar</th>
                                <th>SKU</th>
                                <th>Descrição</th>
                            </tr>
                        </thead>
                        <tbody>
                            {resultadosBuscaProduto.length === 0 && (
                                <tr>
                                    <td colSpan={3} className="text-center">
                                        Nenhum produto encontrado.
                                    </td>
                                </tr>
                            )}
                            {resultadosBuscaProduto.map((produto) => (
                                <tr key={produto.SKU}>
                                    <td className="text-center">
                                        <Form.Check
                                            type="checkbox"
                                            checked={!!produtosSelecionados[produto.SKU]}
                                            onChange={() => toggleProdutoSelecionado(produto)}
                                        />
                                    </td>
                                    <td>{produto.SKU}</td>
                                    <td>{produto.DESCRICAO}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="success"
                        onClick={() => {
                            setShowModalBuscaProduto(false)
                            setShowModalItens(true)
                        }}
                    >
                        Voltar
                    </Button>
                    <Button
                        variant="primary"
                        disabled={Object.keys(produtosSelecionados).length === 0}
                        onClick={() => {
                            setShowModalConfirmarInclusao(true)
                            setShowModalBuscaProduto(false)
                        }}
                    >
                        Confirmar Seleção ({Object.keys(produtosSelecionados).length})
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal Confirmar Inclusão */}
            <Modal
                show={showModalConfirmarInclusao}
                onHide={fecharModalConfirmarInclusao}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Inclusão de Produtos</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Deseja incluir {Object.keys(produtosSelecionados).length} produtos no armazém {armazemSelecionado?.DESCRICAO}?</p>
                    <ul>
                        {Object.values(produtosSelecionados).map((prod) => (
                            <li key={prod.SKU}>
                                {prod.SKU} - {prod.DESCRICAO}{' '}
                                {loadingInclusao[prod.SKU] && <Spinner animation="border" size="sm" />}
                            </li>
                        ))}
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={fecharModalConfirmarInclusao}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={incluirProdutosSelecionados}>
                        Confirmar Inclusão
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
        </>
    )
}

export default ContasList
